/**
 * Enhanced Search Functionality for Shopify
 * This script improves the search functionality to include product descriptions and other fields
 * and prevents searches with less than 2 characters
 */

document.addEventListener('DOMContentLoaded', function() {
  // Find all search forms on the page
  const searchForms = document.querySelectorAll('form[action*="/search"]');
  
  // Add hidden fields to each search form to enable full-text search
  searchForms.forEach(form => {
    // Check if the form already has these fields
    if (!form.querySelector('input[name="options[fields]"]')) {
      // Create hidden input for search fields
      const fieldsInput = document.createElement('input');
      fieldsInput.type = 'hidden';
      fieldsInput.name = 'options[fields]';
      fieldsInput.value = 'title,tag,product_type,variants.title,body,vendor';
      form.appendChild(fieldsInput);
      
      console.log('Enhanced search fields added to form:', form);
    }
  });
  
  // Enhance the predictive search functionality
  if (typeof PredictiveSearch !== 'undefined') {
    // Store the original getSearchResults method
    const originalGetSearchResults = PredictiveSearch.prototype.getSearchResults;
    
    // Override the getSearchResults method to include additional fields
    PredictiveSearch.prototype.getSearchResults = function(searchTerm) {
      console.log('Enhanced predictive search for term:', searchTerm);
      
      // NEW CODE: Check minimum character requirement (matches our class implementation)
      const minimumSearchLength = 2;
      if (searchTerm.length < minimumSearchLength) {
        console.log('Search term too short, minimum length is:', minimumSearchLength);
        // Return a resolved promise with false to indicate no results
        // This will trigger the showMinimumCharactersMessage in the class implementation
        return Promise.resolve(false);
      }
      
      const queryKey = searchTerm.replace(' ', '-').toLowerCase();
      this.setLiveRegionLoadingState();
      
      return new Promise((resolve) => {
        if (this.cachedResults[queryKey]) {
          const hasResults = this.renderSearchResults(this.cachedResults[queryKey]);
          resolve(hasResults);
          return;
        }
        
        // Build a URL with parameters for full-text search
        const url = new URL(window.routes.predictive_search_url, window.location.origin);
        url.searchParams.set('q', searchTerm);
        url.searchParams.set('section_id', 'predictive-search');
        url.searchParams.set('resources[type]', 'product');
        url.searchParams.set('resources[limit]', '24');
        url.searchParams.set('options[fields]', 'title,tag,product_type,variants.title,body,vendor');
        url.searchParams.set('options[unavailable_products]', 'show');
        
        console.log('Enhanced search URL:', url.toString());
        
        fetch(url.toString(), {
          signal: this.abortController.signal
        })
        .then(response => {
          if (!response.ok) {
            throw new Error(response.status);
          }
          return response.text();
        })
        .then(text => {
          const parsedDOM = new DOMParser().parseFromString(text, 'text/html');
          const resultsSection = parsedDOM.querySelector('#shopify-section-predictive-search');
          
          const hasResults = this.checkForResults(resultsSection);
          
          if (hasResults) {
            this.limitProducts(resultsSection);
          }
          
          const resultsMarkup = resultsSection.innerHTML;
          
          this.allPredictiveSearchInstances.forEach(instance => {
            instance.cachedResults[queryKey] = resultsMarkup;
          });
          
          if (hasResults) {
            this.renderSearchResults(resultsMarkup);
          }
          
          resolve(hasResults);
        })
        .catch(error => {
          if (error?.code === 20) {
            resolve(false);
            return;
          }
          this.close();
          throw error;
        });
      });
    };
    
    console.log('Predictive search enhanced to include product descriptions and other fields and minimum character validation');
  }
});
